import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import Form from './components/form';
import { deleteItem, getList as _getList } from '@/api/setting/third-party';
export default {
  name: 'setting-third-party',
  data: function data() {
    return {
      filterData: [{
        name: '所有',
        value: ''
      }, {
        name: '工商信息',
        value: '工商信息'
      }, {
        name: '距离计算',
        value: '距离计算'
      }, {
        name: '物流轨迹',
        value: '物流轨迹'
      }, {
        name: '快递面单',
        value: '快递面单'
      }, {
        name: '经纬度',
        value: '经纬度'
      }, {
        name: '电子函证',
        value: '电子函证'
      }, {
        name: '物流方',
        value: '物流方'
      }],
      currentTableData: [],
      currentPage: 1,
      total: 0,
      loading: false,
      template: null,
      pageSize: 10,
      type: undefined,
      searchKey: undefined
    };
  },
  computed: {
    searchQuery: function searchQuery() {
      var key = this.searchKey ? "n03Name.contains(\"".concat(this.searchKey, "\") ") : '';
      var params = '';
      if (key) {
        params = key;
        if (this.type) {
          params = "".concat(params, " && n03Type == \"").concat(this.type, "\"");
        }
      } else if (this.type) {
        params = "n03Type == \"".concat(this.type, "\"");
      }
      return params;
    }
  },
  methods: {
    create: function create(type, row) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$awaitTo(_this.$dialog(Form, {
                dialog: {
                  title: type === 'new' ? '新增' : '编辑',
                  width: '650px'
                },
                props: {
                  types: _this.filterData.filter(function (item) {
                    return item.value;
                  }),
                  id: row ? row.n03Id : undefined
                }
              }, function (template) {
                _this.template = template;
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.template = null;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _this.getList();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleTakState: function handleTakState(_ref) {
      var value = _ref.value;
      this.type = value;
      this.currentPage = 1;
      this.getList();
    },
    onSearch: function onSearch() {
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    remove: function remove(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$confirm('确定删除?');
            case 1:
              _this2.loading = true;
              _context2.n = 2;
              return _this2.$awaitTo(deleteItem(row.n03Id));
            case 2:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 1);
              err = _yield$_this2$$awaitT2[0];
              _this2.loading = false;
              if (!err) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              _this2.$message.success('操作成功');
              _this2.getList();
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getList: function getList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, res, headers, data, pagination;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              _context3.n = 1;
              return _this3.$awaitTo(_getList({
                PageNumber: _this3.currentPage,
                PageSize: _this3.pageSize,
                SearchQuery: _this3.searchQuery
              }));
            case 1:
              _yield$_this3$$awaitT = _context3.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              res = _yield$_this3$$awaitT2[1];
              _this3.loading = false;
              if (!err) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              headers = res.headers, data = res.data;
              if (Array.isArray(data)) {
                _this3.currentTableData = data;
              }
              pagination = headers['x-pagination'];
              if (pagination) {
                _this3.total = JSON.parse(pagination).totalCount;
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  },
  created: function created() {
    this.getList();
  }
};